import { Code, Text, Heading } from '@scale/scaleui-radix';
import { Column } from '@scale/compass-shared/types';

interface PreviewMetadataUpdateProps {
  columnsToUpdate: Column[];
}

export const PreviewMetadataUpdate = ({ columnsToUpdate }: PreviewMetadataUpdateProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Heading size="2" weight="medium" className="text-gray-700">
        The following metadata will be updated on each task:
      </Heading>
      <div className="flex items-center gap-2 flex-wrap">
        <Text as="p" size="2" className="text-gray-600 flex flex-wrap gap-2">
          {columnsToUpdate.map((column, i) => (
            <div key={column.header}>
              <Code>{column.header}</Code>
              {i < columnsToUpdate.length - 1 && ', '}
            </div>
          ))}
        </Text>
      </div>
    </div>
  );
};

PreviewMetadataUpdate.displayName = 'PreviewMetadataUpdate';
